import { Button as e } from "../button/Button.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
import r from "clsx";
//#region src/components/overlays/OverlayFooter.tsx
function i({ config: i, onCancel: a, pending: o = !1, compact: s = !1, divider: c = !1 }) {
	let { primaryAction: l, secondaryAction: u, leadingContent: d, cancelLabel: f = "Cancel" } = i;
	return /* @__PURE__ */ n("footer", {
		className: r("pf:shrink-0 pf:flex pf:flex-wrap pf:items-center pf:justify-end pf:gap-md pf:border-0 pf:border-t-[0.5px] pf:border-solid", c ? "pf:border-soft-pearl-300" : "pf:border-transparent", s ? "pf:px-xl pf:py-lg" : "pf:px-3xl pf:pt-xl pf:pb-2xl"),
		children: [
			d && /* @__PURE__ */ t("div", {
				className: "pf:me-auto pf:min-w-0 pf:wrap-anywhere",
				children: d
			}),
			u ? /* @__PURE__ */ t(e, {
				...u,
				variant: "secondary",
				size: s ? "sm" : "md",
				disabled: o || u.disabled,
				children: u.label
			}) : /* @__PURE__ */ t(e, {
				variant: "secondary",
				size: s ? "sm" : "md",
				disabled: o,
				onClick: a,
				children: f
			}),
			l && /* @__PURE__ */ t(e, {
				...l,
				variant: "primary",
				size: s ? "sm" : "md",
				disabled: o || l.disabled,
				children: l.label
			})
		]
	});
}
//#endregion
export { i as OverlayFooter };
